import React, { useState, useEffect } from 'react';

import TextField from '@material-ui/core/TextField';
import Modal from 'components/Tvendo/Common/ModalBase';
import { WithApp } from 'contexts/appContext';
import { onlyInteger } from 'hooks/Pipe';

export default WithApp(function ModalCuotaProvider(props) {
  const cuota = props.model;
  const customerPortfolioB = props.model;
  const {mecanica} = props;
  const [bPartnerSelect, setBPartnerSelect] = useState(undefined);
  const [dataChanging, setDataChanging] = useState(customerPortfolioB);
  
  function handleChange(field, value) {
    setDataChanging(prev => ({...prev,[field]: value,}));
  }

  useEffect(() => {
    if (customerPortfolioB.open) {
      if (!customerPortfolioB.id);
      setDataChanging(customerPortfolioB);
    }
  }, [customerPortfolioB.open]);

  useEffect(() => {
    if (cuota.open) setBPartnerSelect(undefined);
  }, [cuota.open]);

  return (
    <>
      <Modal
        title={`Nuevo detalle para mecanica de ventas`}
        model={{ open: cuota.open }}
        setOpen={props.setOpen}
        showNotify={props.showNotify}
        reload={props.reload}
        mecanica={props.mecanica}
        arrDataResponse
        entity='sale/mecanica-detalle'
        dataForce={{
          colgate_mecanica_venta_id: mecanica.id,
          max_coverage: dataChanging.max_coverage || 999,
        }}
      >
        <TextField
          label="Descripcion"
          fullWidth
          type="text"
          name="description"
          margin="normal"
          value={dataChanging.description || ''}
          onChange={(e) => handleChange('description', e.target.value)}
          required
        />
        <TextField
          label="Rango minimo"
          fullWidth
          type="number"
          name="min_coverage"
          margin="normal"
          value={dataChanging.min_coverage || ''}
          onChange={(e) => handleChange('min_coverage', e.target.value)}
          onKeyPress={onlyInteger}
          required
        />
        <TextField
          label="Rango maximo"
          fullWidth
          type="number"
          name="max_coverage"
          margin="normal"
          value={dataChanging.max_coverage || ''}
          onChange={(e) => handleChange('max_coverage', e.target.value)}
          onKeyPress={onlyInteger}
        />
        <TextField
          label="Incentivo vendedor"
          fullWidth
          type="number"
          name="incentivo_vendedor"
          margin="normal"
          value={dataChanging.incentivo_vendedor || ''}
          onChange={(e) => handleChange('incentivo_vendedor', e.target.value)}
          // onKeyPress={onlyInteger}
        />
        <TextField
          label="Incentivo supervisor"
          fullWidth
          type="number"
          name="incentivo_supervisor"
          margin="normal"
          value={dataChanging.incentivo_supervisor || ''}
          onChange={(e) => handleChange('incentivo_supervisor', e.target.value)}
          // onKeyPress={onlyInteger}
        />
      </Modal>
    </>
  );
});
